var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutlook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.999 66.975C127.999 65.975 127.499 65.05 126.624 64.525H126.599L126.549 64.5L82.1991 38.25C81.9991 38.125 81.7991 38 81.5991 37.9C79.8741 37.025 77.8491 37.025 76.1491 37.9C75.9491 38 75.7491 38.125 75.5491 38.25L31.1991 64.5L31.1491 64.525C29.7991 65.375 29.3741 67.15 30.2241 68.5C30.4741 68.9 30.8241 69.225 31.2241 69.475L75.5741 95.725C75.7741 95.85 75.9741 95.975 76.1741 96.075C77.8991 96.95 79.9241 96.95 81.6241 96.075C81.8241 95.975 82.0241 95.85 82.2241 95.725L126.574 69.475C127.474 68.95 127.999 68 127.999 66.975Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3744 49.45H65.4994V76.125H36.3744V49.45ZM122.049 22.325V10.125C122.124 7.07498 119.699 4.54998 116.649 4.47498H41.1244C38.0744 4.54998 35.6494 7.07498 35.7244 10.125V22.325L80.3744 34.225L122.049 22.325Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7246 22.325H65.4996V49.125H35.7246V22.325Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.25 22.325H65.5V49.125L95.25 75.9H122.05V49.125L95.25 22.325Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5 49.125H95.25V75.925H65.5V49.125Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5 75.9H95.25V102.7H65.5V75.9Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.375 76.125H65.5V100.375H36.375V76.125Z",
    fill: "#14447D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.25 75.9H122.05V102.7H95.25V75.9Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.625 69.3L126.575 69.325L82.2254 94.275C82.0254 94.4 81.8254 94.5 81.6254 94.6C80.8754 94.95 80.0504 95.15 79.2254 95.2L76.8004 93.775C76.6004 93.675 76.4004 93.55 76.2004 93.425L31.2504 67.8L29.7754 66.975V117.475C29.8004 120.85 32.5504 123.55 35.9254 123.525H121.975C122.025 123.525 122.075 123.5 122.125 123.5C122.825 123.45 123.55 123.3 124.2 123.075C124.5 122.95 124.775 122.8 125.025 122.65C125.225 122.525 125.575 122.3 125.575 122.3C127.1 121.175 128 119.4 128 117.5V67C128 67.95 127.475 68.825 126.625 69.3Z",
    fill: "url(#paint0_linear_17_43)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M125.626 66.775V69.875L79.2508 101.8L31.2258 67.825C31.2258 67.8 31.2008 67.8 31.2008 67.8L26.8008 65.15V62.925L28.6258 62.9L32.4758 65.1L32.5758 65.125L32.9008 65.325C32.9008 65.325 78.0258 91.075 78.1508 91.125L79.8758 92.125C80.0258 92.075 80.1758 92 80.3508 91.95C80.4508 91.9 125.151 66.725 125.151 66.725L125.626 66.775Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.625 69.3L126.575 69.325L82.2254 94.275C82.0254 94.4 81.8254 94.5 81.6254 94.6C79.9004 95.45 77.9004 95.45 76.1754 94.6C75.9754 94.5 75.7754 94.4 75.5754 94.275L31.2254 69.325L31.1754 69.3C30.3254 68.825 29.7754 67.95 29.7754 66.975V117.475C29.8004 120.85 32.5504 123.55 35.9254 123.525H121.875C125.25 123.55 128 120.825 128.025 117.475V66.975C128 67.95 127.475 68.825 126.625 69.3Z",
    fill: "#1490DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M82.875 93.925L82.2 94.3C82 94.425 81.8 94.525 81.6 94.625C80.875 94.975 80.075 95.2 79.25 95.25L96.125 115.2L125.55 122.3C126.35 121.7 127 120.9 127.425 119.975L82.875 93.925Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M85.875 92.225L82.2 94.3C82 94.425 81.8 94.525 81.6 94.625C80.875 94.975 80.075 95.2 79.25 95.25L87.15 117.05L125.575 122.3C127.1 121.175 127.975 119.375 127.975 117.5V116.85L85.875 92.225Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 123.525H121.875C123.2 123.525 124.475 123.125 125.55 122.325L76.8 93.8C76.6 93.7 76.4 93.575 76.2 93.45L31.25 67.8H31.225L29.75 66.975V117.3C29.775 120.75 32.55 123.525 36 123.525Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M71.4504 33.725V97.225C71.4504 99.45 70.1004 101.45 68.0254 102.275C67.3754 102.55 66.7004 102.7 66.0004 102.7H29.7754V31.25H35.7254V28.275H66.0004C69.0004 28.3 71.4254 30.725 71.4504 33.725Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M68.4754 36.7V100.2C68.4754 100.925 68.3254 101.625 68.0254 102.275C67.2004 104.325 65.2254 105.65 63.0254 105.65H29.7754V31.25H63.0254C63.9004 31.25 64.7504 31.45 65.5004 31.875C67.3254 32.8 68.4754 34.675 68.4754 36.7Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M68.4754 36.7V94.25C68.4504 97.25 66.0254 99.7 63.0254 99.725H29.7754V31.25H63.0254C63.9004 31.25 64.7504 31.45 65.5004 31.875C67.3254 32.8 68.4754 34.675 68.4754 36.7Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M65.5004 36.7V94.25C65.5004 97.25 63.0754 99.7 60.0504 99.725H29.7754V31.25H60.0504C63.0504 31.25 65.5004 33.7 65.5004 36.7Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.45 31.25H60.025C63.05 31.25 65.475 33.7 65.475 36.7V91.275C65.475 94.3 63.025 96.725 60.025 96.725H5.45C2.45 96.75 0 94.3 0 91.3V36.7C0 33.7 2.45 31.25 5.45 31.25Z",
    fill: "url(#paint1_linear_17_43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0493 54.15C18.3993 51.275 20.5743 48.875 23.2743 47.275C26.2743 45.55 29.6993 44.7 33.1743 44.8C36.3993 44.725 39.5493 45.55 42.3493 47.15C44.9743 48.7 47.0743 51 48.4243 53.725C49.8743 56.725 50.6243 60.05 50.5493 63.4C50.6243 66.9 49.8743 70.375 48.3493 73.525C46.9743 76.35 44.7993 78.725 42.0993 80.325C39.1993 81.975 35.9243 82.825 32.5993 82.75C29.3243 82.825 26.0743 82 23.2243 80.375C20.5993 78.775 18.4493 76.5 17.0743 73.75C15.5993 70.775 14.8743 67.5 14.9243 64.2C14.8743 60.725 15.5993 57.3 17.0493 54.15ZM23.6993 70.3C24.4243 72.1 25.6243 73.675 27.1993 74.825C28.7993 75.95 30.7243 76.525 32.6743 76.475C34.7493 76.55 36.7993 75.95 38.5243 74.775C40.0743 73.625 41.2743 72.05 41.9243 70.25C42.6743 68.225 43.0493 66.075 42.9993 63.925C43.0243 61.75 42.6743 59.575 41.9743 57.525C41.3493 55.675 40.1993 54.025 38.6743 52.8C36.9993 51.55 34.9493 50.925 32.8743 51.025C30.8743 50.975 28.9243 51.55 27.2743 52.7C25.6743 53.85 24.4243 55.45 23.6993 57.275C22.0993 61.45 22.0993 66.1 23.6993 70.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.25 22.325H122.05V49.125H95.25V22.325Z",
    fill: "#50D9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17_43",
    x1: 78.8879,
    y1: 66.975,
    x2: 78.8879,
    y2: 123.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35B8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28A8EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17_43",
    x1: 11.3722,
    y1: 26.991,
    x2: 54.0987,
    y2: 100.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1784D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#107AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A63C9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlook);
export default __webpack_public_path__ + "static/media/outlook.9bddc30302bd6ad44c1cf99969506f4d.svg";
export { ForwardRef as ReactComponent };